import { render } from "./OrderHistoryEntry.vue?vue&type=template&id=64b93c60&scoped=true"
import script from "./OrderHistoryEntry.vue?vue&type=script&lang=js"
export * from "./OrderHistoryEntry.vue?vue&type=script&lang=js"

import "./OrderHistoryEntry.vue?vue&type=style&index=0&id=64b93c60&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b93c60"]])

export default __exports__